import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import PaginationBar from "../../component/PaginationBar";
import ButtonCompo from "../../component/ButtonCompo";

function LetterHistory() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.letterGenerate === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [letterHistory, setLetterHistory] = useState([]);

  // fetch letter history
  async function getHistory() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/history/${page}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLetterHistory(res.data?.data?.data || []);
      setTotalPage(res.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("History fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // delete letter
  async function deleteLetter(letterId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/letter/delete/${letterId}`,
        method: "delete",
        withCredentials: true,
      });
      setReload(prev => !prev);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("History fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getHistory();
  }, [page, reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Generated Letter History
          </h1>
          <div className="mt-5">
            {letterHistory?.length === 0 ? (
              <div>No History Found</div>
            ) : (
              <div>
                <Table>
                  <TableHead>
                    <TableRow className="bg-blue-500">
                      <TableCell className="!text-white !text-center">SL No</TableCell>
                      <TableCell className="!text-white !text-center">Title</TableCell>
                      <TableCell className="!text-white !text-center">Letter Link</TableCell>
                      <TableCell className="!text-white !text-center">Generated Date</TableCell>
                      <TableCell className="!text-white !text-center">Employee ID</TableCell>
                      <TableCell className="!text-white !text-center">Email ID</TableCell>
                      <TableCell className="!text-white !text-center">Delete</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="border">
                    {letterHistory.map((letter, i) => (
                      <TableRow key={i}>
                        <TableCell className="!text-center">{i + 1}</TableCell>
                        <TableCell className="!text-center">{letter.title}</TableCell>
                        <TableCell className="!text-center">
                          <Link to={letter?.letterLink} target="_blank" className="text-blue-500 font-medium">View Letter</Link>
                        </TableCell>
                        <TableCell className="!text-center">{letter.createdAt ? new Date(letter.createdAt).toLocaleDateString("en-IN") : "N/A"}</TableCell>
                        <TableCell className="!text-center">{letter.employeeId || "NIL"}</TableCell>
                        <TableCell className="!text-center">{letter.email || "NIL"}</TableCell>
                        <TableCell className="!text-center">
                            <ButtonCompo onClick={() => deleteLetter(letter?._id)} color={"error"}>Delete</ButtonCompo>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <PaginationBar attendancePage={page} setAttendancePage={setPage} totalAttendancePage={totalPage} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default LetterHistory;
